import React from 'react';

import {connect} from 'react-redux';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';
import {Price} from 'components/price/price';
import {isSecondFrameUpsellDisabled} from 'desktop/pages/cart/store/selectors';
import {CartItemEyeglassesOfferFrameType} from 'desktop/pages/cart/types';
import {ApplicationStoreType} from 'desktop/store';

import s from './frame.scss';

export type PropsType = CartItemEyeglassesOfferFrameType & {
    addUpsellHandler: () => void;
    quickLookHandler: () => void;
    isDisabled: boolean;
};

/**
 * UpsellFrame component
 * @param {PropsType} props for component
 * @returns {React.Element | null} component layout
 */
export const UpsellFrame: React.FC<PropsType> = ({
    addUpsellHandler,
    img,
    isDisabled,
    name,
    price,
    quickLookHandler,
    specialPrice,
}) => (
    <div className={s.scholarBlock} data-test-name="frameUpsellItem">
        <div className={s.imageOuterWrapper}>
            <div className={s.imageWrapper}>
                <CloudinaryImage alt="scholar" className={s.scholarImg} src={img} />
            </div>
        </div>
        <div className={s.scholarName}>{name}</div>
        <div className={s.priceBlock}>
            <span className={s.priceOld}>
                <Price>{price}</Price>
            </span>
            <span className={s.priceNew} data-test-name="price">
                <Price>{specialPrice}</Price>
            </span>
        </div>
        <div className={s.buttonBlock}>
            <button className={s.button} onMouseDown={quickLookHandler} type="button">
                View
            </button>
            <button
                className={s.button}
                data-test-name="addToCart"
                disabled={isDisabled}
                onMouseDown={addUpsellHandler}
                type="button"
            >
                Add
            </button>
        </div>
    </div>
);

/**
 * Map state to props
 * @param {ApplicationStoreType} state - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (state: ApplicationStoreType) => ({
    isDisabled: isSecondFrameUpsellDisabled(state),
});

export const UpsellFrameConnected = connect(mapStateToProps)(UpsellFrame);
